// File: PaymentGatewayAggregatorSolutions.jsx
import React from "react";

export default function PaymentGatewayAggregatorSolutions() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Payment Gateway Aggregator Solutions
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses with compliant payment gateway setup.
          </p>
          <p className="text-gray-700">
            Complete payment gateway integration including Razorpay/PayU/Paytm onboarding, PCI-DSS compliance, KYC verification, merchant current account activation, settlement reconciliation, and chargeback management for seamless digital payments.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Payment gateway aggregator fintech compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/50987/pexels-photo-50987.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Payment gateway aggregator solutions fintech"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete KYC documentation for payment gateway approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business KYC (GST, PAN, Incorporation certificate)</li>
                <li>Bank account details and statements</li>
                <li>Website/app details and privacy policy</li>
                <li>Director/Proprietor identity proofs</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Fintech compliance expertise ensuring 7-day payment gateway activation.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Multi-Aggregator Onboarding
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete onboarding for Razorpay, PayU, Paytm, CCAvenue, Instamojo, PhonePe, including merchant KYC verification, risk assessment clearance, PCI-DSS compliance checklist, current account linkage, API key generation, and live production activation within 7 working days.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  PCI-DSS &amp; RBI Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full compliance assurance including PCI Level 1 certification, data security implementation, 3DSecure mandate, fraud monitoring setup, settlement T+2 guarantee, chargeback handling SOP, RBI PSS Act adherence, and transaction limit enhancement ensuring zero compliance rejections.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Integration &amp; Optimization
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end technical support including payment page customization, WooCommerce/Shopify/WordPress plugins, mobile app SDK integration, webhook setup, daily settlement reconciliation, refund automation, analytics dashboard, and transaction optimization for maximum conversion rates.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
